import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import Card from '../components/card';
import { PercentTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const OtherOfferRate = ({ model, onChange, ...cardProps }) => {
  return (
    <Card
      title="To better serve you we'd like to understand the best rate you've been offered so far."
      {...cardProps}
    >
      <p style={{ marginBottom: 0 }}>What type of loan is it?</p>
      <SelectField
        labelStyle={{ paddingLeft: 0 }}
        underlineStyle={{ margin: '-1px 24px -1px 0' }}
        value={model.get('otherOfferProduct')}
        onChange={(event, _, payload) => onChange('otherOfferProduct', payload)}
        hintText="Select One"
      >
        <MenuItem value="Fixed30" primaryText="30 Year Fixed" />
        <MenuItem value="Fixed20" primaryText="20 Year Fixed" />
        <MenuItem value="Fixed15" primaryText="15 Year Fixed" />
        <MenuItem value="Fixed10" primaryText="10 Year Fixed" />
        <MenuItem value="ARM10" primaryText="10/1 ARM" />
        <MenuItem value="ARM7" primaryText="7/1 ARM" />
        <MenuItem value="ARM5" primaryText="5/1 ARM" />
        <MenuItem value="Other" primaryText="Other Product" />
      </SelectField>
      <p style={{ margin: '32px 0 -8px' }}>What is the interest rate?</p>
      <PercentTextField
        value={model.get('otherOfferRate')}
        onChange={onChange.bind(null, 'otherOfferRate')}
        style={style.threeQuarters}
        floatingLabelText="Interest Rate (%)"
      />
    </Card>
  );
};

OtherOfferRate.completed = ({ model }) =>
  ['Fixed30', 'Fixed20', 'Fixed15', 'Fixed10', 'ARM10', 'ARM7', 'ARM5', 'Other'].includes(
    model.get('otherOfferProduct')
  ) && !PercentTextField.validate(model.get('otherOfferRate'));

OtherOfferRate.id = 'OtherOfferRate';

export default LoanCard(OtherOfferRate);



// WEBPACK FOOTER //
// ./src/cards/other-offer-rate.js